import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EntryPaymentsService } from '../../data-access/entryPayments.service';
import { Subject } from 'rxjs';
import { loadScript, PayPalButtonsComponent } from "@paypal/paypal-js";
import { PAYPAL_INNATELY_CLIENT_ID, PAYPAL_INNATELY_VENDOR_CLIENT_ID } from '@equine-ui-nx/injection-tokens';
import { Router } from '@angular/router';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';


@Component({
  selector: 'equine-ui-nx-show-entry-pay-with-paypal',
  standalone: true,
  imports: [
    CommonModule,
    MatSnackBarModule
  ],
  templateUrl: './show-entry-pay-with-paypal.component.html',
  styleUrl: './show-entry-pay-with-paypal.component.scss',
})
export class ShowEntryPayWithPaypalComponent implements OnInit, OnDestroy {

  @Input({ required: true }) showPaymentDetailsIds!: string[];
  @Input() fromEntryFee = false;
  @Output() success = new EventEmitter<void>();

  private entryPaymentsService = inject(EntryPaymentsService);
  private paypalInnatelyClientId = inject(PAYPAL_INNATELY_CLIENT_ID);
  private paypalInnatelyVendorClientId = inject(PAYPAL_INNATELY_VENDOR_CLIENT_ID);

  private router = inject(Router);
  private _snackBar = inject(MatSnackBar);

  public paypalButtons: PayPalButtonsComponent | null = null;
  loading = signal(true);

  private unsubscribe$ = new Subject<void>();

  ngOnInit(): void {
    this.getPaypalOrderId();
  }

  getPaypalOrderId() {
    this.loading.set(true);
    this.loadPaypalButton();
  }

  loadPaypalButton() {
    loadScript({
      clientId: this.fromEntryFee ? this.paypalInnatelyVendorClientId : this.paypalInnatelyClientId,
      components: ['buttons'],
      disableFunding: ['sofort', 'card'],
      intent: 'capture'
    }).then((paypal) => {
      if (!paypal) {
        return;
      } else {
        this.paypalButtons = (paypal as any).Buttons({
          style: {
            layout: 'horizontal',
            color: 'gold',
            shape: 'rect',
            label: 'pay',
            tagline: true
          },
          createOrder: () => {
            return new Promise((resolve, reject) => {
              if (this.fromEntryFee) {
                this.entryPaymentsService.getPaypalOrderForShowFee(this.showPaymentDetailsIds)
                  .subscribe({
                    next: (response) => {
                      resolve(response.order.id);
                    },
                    error: (error) => {
                      reject(error);
                    }
                  });
              } else {
                debugger
                this.entryPaymentsService.getPaypalOrderId(this.showPaymentDetailsIds)
                  .subscribe({
                    next: (order) => {
                      resolve(order.paypalOrder.id);
                    },
                    error: (error) => {
                      reject(error);
                    }
                  });
              }
            });
          },
          onApprove: (orderData: any) => {
            return new Promise((resolve, reject) => {
              if (this.fromEntryFee) {
                this.entryPaymentsService.captureShowFees(orderData.orderID, this.showPaymentDetailsIds)
                  .subscribe({
                    next: (success) => {
                      this.success.emit();
                      resolve(success);
                    },
                    error: (error) => {
                      reject(error);
                    }
                  });
              } else {
                this.entryPaymentsService.captureEntries(orderData.orderID, this.showPaymentDetailsIds)
                  .subscribe({
                    next: (success) => {
                      debugger
                      this.router.navigate(['payments', 'success']);
                      this.success.emit();
                      resolve(success);
                    },
                    error: (error) => {
                      reject(error);
                    }
                  });
              }
            });
          },
          onError: (error: { error: { message: string } }) => {
            if (error?.error?.message) {
              this._snackBar.open(`Error: ${error.error.message}`, 'Dismiss')
            } else {
              this._snackBar.open(`Error: an error occured. Please try again`, 'Dismiss')
            }
          },
        });

        this.paypalButtons?.render('#paypalButtons');
      }
    }).catch((error) => {
      this._snackBar.open(`Error: an error occured. Please try again`, 'Dismiss')
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
